var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',{staticClass:"form-wrap",style:(_vm.formWrapExtraStyle)},[_vm._t("header"),_vm._t("content"),_vm._t("footer",[_c('div',{staticClass:"version-wrap",attrs:{"slot":"footer"},slot:"footer"},[_c('version')],1)])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }